export interface CalculationResult {
  so_luong: number;
  thanh_tien: number;
  thue: number;
  tong_tien: number;
}

const Round = (value: number): number => {
  const numeric = Number(value) || 0;
  return Math.round(numeric * 100) / 100;
};

export function calculateTotals(detailItems: MuaHangRecord[] = []): CalculationResult {
  const so_luong = detailItems.reduce((sum, item) => sum + (parseFloat(item.so_luong) || 0), 0);
  const thanh_tien = Round(detailItems.reduce((sum, item) => sum + (parseFloat(item.tien_nt) || 0), 0));
  const thue = Round(detailItems.reduce((sum, item) => sum + (parseFloat(item.thue_nt) || 0), 0));
  const tong_tien = Round(thanh_tien + thue);

  return {
    so_luong,
    thanh_tien,
    thue,
    tong_tien
  };
}

export const handleUpdateRowFields = (
  row: MuaHangRecord,
  field: string,
  newValue: MuaHangRecord,
  taxRate?: number | null
) => {
  if (field === 'so_luong' || field === 'gia_nt' || field === 'tl_ck' || field === 'tien_nt') {
    const so_luong = field === 'so_luong' ? newValue : row.so_luong;
    const gia_nt = field === 'gia_nt' ? newValue : row.gia_nt;
    const tl_ck = field === 'tl_ck' ? newValue : row.tl_ck;

    const calculated_tien_nt =
      field === 'tien_nt' ? Number(newValue) || 0 : (Number(so_luong) || 0) * (Number(gia_nt) || 0);
    const tien_nt = Round(calculated_tien_nt);
    const ck_nt = Round((tien_nt * (Number(tl_ck) || 0)) / 100);

    const numericTaxRate =
      taxRate !== undefined && taxRate !== null && !Number.isNaN(Number(taxRate)) ? Number(taxRate) : null;

    return {
      ...(field !== 'tien_nt' ? { tien_nt } : {}),
      ck_nt,
      ...(numericTaxRate !== null ? { thue_nt: Round((tien_nt * numericTaxRate) / 100) } : {})
    };
  }
  return {};
};
